import React from "react";
import { joinClasses } from "../../utils/joinClasses";
const sizeMap = {
    none: undefined,
    xs: "size-3",
    sm: "size-4",
    md: "size-5",
    lg: "size-6",
    xl: "size-8",
    "2xl": "size-12",
};
export const Icon = ({ path, size = "md", className, title, ...props }) => (React.createElement("svg", { className: joinClasses([sizeMap[size], className]), role: title ? "img" : "presentation", viewBox: "0 0 24 24", ...props },
    title && React.createElement("title", null, title),
    React.createElement("path", { d: path, fill: "currentColor" })));
